import LC1 from "./LC1";
import LC2 from "./LC2";
import Pillars from "./Pillars";
import Slogan from "./Slogan";
import bottom_bg from "../assets/images/bottom_bg.png";
import skochSilverAward from "../assets/awards/skoch_silver_award.png";
import primeMinisterAward from "../assets/awards/prime_minister_award.png";

// Reusable AwardCard Component
const AwardCard = ({ imgSrc, alt, children }) => {
  return (
    <div className="bg-white shadow-lg rounded-xl p-4 sm:p-6 flex flex-col items-center w-full max-w-[480px] min-h-[300px] transition-transform duration-300 hover:scale-[1.02]">
      <div className="w-full flex justify-center">
        <img
          src={imgSrc}
          alt={alt}
          className="rounded-t-lg w-full max-w-[320px] sm:max-w-[380px] h-auto object-contain"
        />
      </div>
      <p className="mt-4 text-center font-medium text-sm sm:text-base md:text-lg">
        {children}
      </p>
    </div>
  );
};

const LandingComponent = () => {
  return (
    <div className="relative w-full overflow-hidden">
      <LC1 />
      <LC2 />

      {/* Recognitions Section */}
      <section className="relative w-full mt-8 sm:mt-12 lg:mt-16 mb-16">
        {/* Background only for recognition section */}
        <div
          className="absolute top-0 left-0 w-full h-full rounded-b-3xl overflow-hidden"
          style={{
            backgroundImage: `url(${bottom_bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: -10,
            height: "calc(100% - 120px)",
          }}
        />

        <div className="relative z-10 w-full max-w-screen-2xl mx-auto flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center py-4 sm:py-8">
            Recognitions
          </h1>

          {/* Award Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10 lg:gap-12 w-full place-items-center">
            <AwardCard
              imgSrc={skochSilverAward}
              alt="SKOCH Silver Award"
            >
              <strong>SKOCH Silver Award :</strong> Annupur Smart Classes
            </AwardCard>

            <AwardCard
              imgSrc={primeMinisterAward}
              alt="Prime Minister Award"
            >
              <strong>Prime Minister's Award</strong> <br /> for Excellence in
              Public Administration 2020 <br /> Innovation - General Category
              (3rd Rank)
            </AwardCard>
          </div>
        </div>

        {/* Other Sections */}
        <Slogan />
        <Pillars />
      </section>
    </div>
  );
};

export default LandingComponent;
